const checkForPerformanceCookie = callback => {
    if (window.performanceCookieAccept) {
        callback();
    } else {
        document.addEventListener('performanceCookieAccepted', () => {
            callback();
        });
    }
};

const addMagnificPopup = selector => {
    const $element = $(selector);

    if ($element.length === 0) {
        return;
    }

    $element.magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
    });

    $element.on('click', event => {
        event.preventDefault();
    });
};

export function initVideoModals() {
    checkForPerformanceCookie(() => addMagnificPopup('.card-video'));
    checkForPerformanceCookie(() => addMagnificPopup('.carousel-video'));
}
